import { create } from 'zustand'

export type PersonaType = 'engineer' | 'researcher' | 'speaker' | 'educator' | null

export interface PersonaInfo {
  id: PersonaType
  title: string
  titleTR: string
  subtitle: string
  subtitleTR: string
  color: string
  colorRGB: string
  icon: string
}

export const PERSONAS: Record<Exclude<PersonaType, null>, PersonaInfo> = {
  engineer: {
    id: 'engineer',
    title: 'AI Engineer',
    titleTR: 'Yapay Zeka Mühendisi',
    subtitle: 'Building intelligent systems with LLMs, LangChain, and modern AI tools',
    subtitleTR: 'LLM, LangChain ve modern AI araçlarıyla akıllı sistemler geliştiriyorum',
    color: '#22d3ee',
    colorRGB: '34, 211, 238',
    icon: '</>',
  },
  researcher: {
    id: 'researcher',
    title: 'AI Researcher',
    titleTR: 'Yapay Zeka Araştırmacısı',
    subtitle: 'PhD candidate at ITU, exploring LLM agents and cognitive architectures',
    subtitleTR: 'İTÜ\'de doktora öğrencisi, LLM ajanları ve bilişsel mimariler üzerine çalışıyorum',
    color: '#a78bfa',
    colorRGB: '167, 139, 250',
    icon: '🔬',
  },
  speaker: {
    id: 'speaker',
    title: 'Tech Speaker',
    titleTR: 'Teknoloji Konuşmacısı',
    subtitle: 'Sharing AI insights at universities and tech conferences across Turkey',
    subtitleTR: 'Türkiye genelinde üniversitelerde ve teknoloji konferanslarında AI paylaşımları',
    color: '#f97316',
    colorRGB: '249, 115, 22',
    icon: '🎤',
  },
  educator: {
    id: 'educator',
    title: 'Educator',
    titleTR: 'Eğitimci',
    subtitle: 'Teaching AI and intelligent systems at universities, mentoring the next generation',
    subtitleTR: 'Üniversitelerde yapay zeka ve akıllı sistemler dersleri veriyorum, yeni nesli yetiştiriyorum',
    color: '#14b8a6',
    colorRGB: '20, 184, 166',
    icon: '📚',
  },
}

interface PersonaState {
  selectedPersona: PersonaType
  isHovering: PersonaType

  // Actions
  setPersona: (persona: PersonaType) => void
  setHovering: (persona: PersonaType) => void
  clearPersona: () => void
}

export const usePersonaStore = create<PersonaState>()((set, get) => ({
  selectedPersona: null,
  isHovering: null,

  setPersona: (persona) => {
    set({ selectedPersona: persona })
    // Apply theme class to document
    if (persona) {
      document.documentElement.className = `theme-${persona}`
    } else {
      document.documentElement.className = ''
    }
  },

  setHovering: (persona) => {
    set({ isHovering: persona })
  },

  clearPersona: () => get().setPersona(null),
}))
